function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "System Icon /Copy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  id: "filter-1"
}, React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Explorer-Desktop@1440px",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "05-Order-Detail_Filled",
  transform: "translate(-1104.000000, -653.000000)"
}, React.createElement("g", {
  id: "Detail",
  transform: "translate(496.000000, 258.000000)"
}, React.createElement("g", {
  id: "Group-2",
  transform: "translate(456.000000, 344.000000)"
}, React.createElement("g", {
  id: "Group-4",
  transform: "translate(130.000000, 40.000000)"
}, React.createElement("g", {
  id: "System-Icon-/Copy",
  transform: "translate(22.000000, 11.000000)",
  filter: "url(#filter-1)"
}, React.createElement("g", null, React.createElement("path", {
  d: "M14,0 L14,9.91666667 L9.916,9.916 L9.91666667,14 L0,14 L0,4.08333333 L4.083,4.083 L4.08333333,0 L14,0 Z M8.16666667,5.83333333 L1.75,5.83333333 L1.75,12.25 L8.16666667,12.25 L8.16666667,5.83333333 Z M12.25,1.75 L5.83333333,1.75 L5.833,4.083 L9.91666667,4.08333333 L9.916,8.166 L12.25,8.16666667 L12.25,1.75 Z",
  id: "Copy",
  fill: "#073C50"
}))))))));

var SvgCopyIcon = function SvgCopyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCopyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CopyIcon.1498c507.svg";
export { ForwardRef as ReactComponent };